import { z } from "zod/v3";
import { QuestionType } from "@/components/AssessmentQuestion/types";

const fileSchema = z
  .instanceof(File)
  .optional()
  .refine((file) => !file || file.size <= 10 * 1024 * 1024, "File size must be less than 10MB")
  .refine((file) => !file || file.type === "application/pdf", "Only PDF files are allowed");

const answerSchema = z
  .object({
    questionId: z.string(),
    questionType: z.nativeEnum(QuestionType),
    textAnswer: z.string().optional(),
    selectedOptionId: z.string().optional(),
    selectedOptionIds: z.array(z.string()).optional()
  })
  .refine(
    (data) => {
      if (data.questionType === QuestionType.OPEN_TEXT) {
        return !!data.textAnswer && data.textAnswer.length > 0;
      }
      if (data.questionType === QuestionType.SINGLE_SELECT || data.questionType === QuestionType.MULTI_CHOICE) {
        return !!data.selectedOptionId;
      }
      if (data.questionType === QuestionType.MULTI_SELECT) {
        return data.selectedOptionIds && data.selectedOptionIds.length > 0;
      }
      return false;
    },
    { message: "Answer is required" }
  );

export const createJobApplicationSchema = (isExecuSearch: boolean) =>
  z.object({
    pgaId: z.string().optional().or(z.literal("")),
    firstName: z.string().optional().or(z.literal("")),
    lastName: z.string().optional().or(z.literal("")),
    email: z.string().optional().or(z.literal("")),
    phone: z.string().optional().or(z.literal("")),
    website: z.string().optional().or(z.literal("")),

    city: isExecuSearch ? z.string().min(1, "City is required") : z.string().optional().or(z.literal("")),
    state: isExecuSearch ? z.string().min(1, "State is required") : z.string().optional().or(z.literal("")),
    currentOrMostRecentPosition: isExecuSearch
      ? z.string().min(1, "Current or most recent position is required")
      : z.string().optional().or(z.literal("")),
    currentOrMostRecentEmployer: isExecuSearch
      ? z.string().min(1, "Current or most recent employer is required")
      : z.string().optional().or(z.literal("")),
    referralSource: isExecuSearch
      ? z.array(z.string()).min(1, "At least one referral source is required")
      : z.array(z.string()).optional(),

    resume: z
      .instanceof(File, { message: "Resume is required" })
      .refine((file) => file.size <= 5 * 1024 * 1024, "File size must be less than 10MB")
      .refine((file) => file.type === "application/pdf", "Only PDF files are allowed"),
    coverLetter: fileSchema,

    customAnswers: z.array(answerSchema).optional()
  });

export type CreateJobApplicationFormData = z.infer<ReturnType<typeof createJobApplicationSchema>>;
